export default __webpack_public_path__ + "static/media/img8.d2aa2be6.jpg";